// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file gdx/common/v1/profile.proto (package gdx.common.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, Timestamp } from "@bufbuild/protobuf";

/**
 * Enumeration of possible profile statuses.
 *
 * @generated from enum gdx.common.v1.AccountStatus
 */
export enum AccountStatus {
  /**
   * @generated from enum value: ACCOUNT_STATUS_INVALID = 0;
   */
  INVALID = 0,

  /**
   * @generated from enum value: ACCOUNT_STATUS_ACTIVE = 1;
   */
  ACTIVE = 1,

  /**
   * @generated from enum value: ACCOUNT_STATUS_DEACTIVATED = 2;
   */
  DEACTIVATED = 2,

  /**
   * @generated from enum value: ACCOUNT_STATUS_DELETED = 3;
   */
  DELETED = 3,

  /**
   * @generated from enum value: ACCOUNT_STATUS_BANNED = 4;
   */
  BANNED = 4,
}
// Retrieve enum metadata with: proto3.getEnumType(AccountStatus)
proto3.util.setEnumType(AccountStatus, "gdx.common.v1.AccountStatus", [
  { no: 0, name: "ACCOUNT_STATUS_INVALID" },
  { no: 1, name: "ACCOUNT_STATUS_ACTIVE" },
  { no: 2, name: "ACCOUNT_STATUS_DEACTIVATED" },
  { no: 3, name: "ACCOUNT_STATUS_DELETED" },
  { no: 4, name: "ACCOUNT_STATUS_BANNED" },
]);

/**
 * Enumerates all possible confirmation code types.
 *
 * @generated from enum gdx.common.v1.CodeType
 */
export enum CodeType {
  /**
   * @generated from enum value: CODE_TYPE_INVALID = 0;
   */
  INVALID = 0,

  /**
   * @generated from enum value: CODE_TYPE_SUBSCRIPTION_CANCELLATION = 1;
   */
  SUBSCRIPTION_CANCELLATION = 1,
}
// Retrieve enum metadata with: proto3.getEnumType(CodeType)
proto3.util.setEnumType(CodeType, "gdx.common.v1.CodeType", [
  { no: 0, name: "CODE_TYPE_INVALID" },
  { no: 1, name: "CODE_TYPE_SUBSCRIPTION_CANCELLATION" },
]);

/**
 * Short version of user profile.
 *
 * @generated from message gdx.common.v1.ProfilePreview
 */
export class ProfilePreview extends Message<ProfilePreview> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: gdx.common.v1.ProfilePhoto avatar = 2;
   */
  avatar?: ProfilePhoto;

  /**
   * @generated from field: string name = 3;
   */
  name = "";

  /**
   * @generated from field: uint32 age = 4;
   */
  age = 0;

  /**
   * @generated from field: bool is_online = 5;
   */
  isOnline = false;

  /**
   * @generated from field: string location_name = 6;
   */
  locationName = "";

  /**
   * @generated from field: bool is_locked = 7;
   */
  isLocked = false;

  /**
   * @generated from field: gdx.common.v1.AccountStatus status = 8;
   */
  status = AccountStatus.INVALID;

  /**
   * @generated from field: string email = 9;
   */
  email = "";

  /**
   * @generated from field: gdx.common.v1.Timezone timezone = 10;
   */
  timezone?: Timezone;

  /**
   * @generated from field: string registration_ip = 11;
   */
  registrationIp = "";

  /**
   * @generated from field: string registration_country_code = 13;
   */
  registrationCountryCode = "";

  /**
   * @generated from field: google.protobuf.Timestamp last_action_time = 12;
   */
  lastActionTime?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp subscription_expires_time = 14;
   */
  subscriptionExpiresTime?: Timestamp;

  constructor(data?: PartialMessage<ProfilePreview>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.common.v1.ProfilePreview";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "avatar", kind: "message", T: ProfilePhoto },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "age", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 5, name: "is_online", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "location_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "is_locked", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 8, name: "status", kind: "enum", T: proto3.getEnumType(AccountStatus) },
    { no: 9, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "timezone", kind: "message", T: Timezone },
    { no: 11, name: "registration_ip", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "registration_country_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "last_action_time", kind: "message", T: Timestamp },
    { no: 14, name: "subscription_expires_time", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ProfilePreview {
    return new ProfilePreview().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ProfilePreview {
    return new ProfilePreview().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ProfilePreview {
    return new ProfilePreview().fromJsonString(jsonString, options);
  }

  static equals(a: ProfilePreview | PlainMessage<ProfilePreview> | undefined, b: ProfilePreview | PlainMessage<ProfilePreview> | undefined): boolean {
    return proto3.util.equals(ProfilePreview, a, b);
  }
}

/**
 * Profile presentation with tags.
 *
 * @generated from message gdx.common.v1.ProfileTagsView
 */
export class ProfileTagsView extends Message<ProfileTagsView> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string name = 2;
   */
  name = "";

  /**
   * @generated from field: repeated string tags = 3;
   */
  tags: string[] = [];

  constructor(data?: PartialMessage<ProfileTagsView>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.common.v1.ProfileTagsView";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "tags", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ProfileTagsView {
    return new ProfileTagsView().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ProfileTagsView {
    return new ProfileTagsView().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ProfileTagsView {
    return new ProfileTagsView().fromJsonString(jsonString, options);
  }

  static equals(a: ProfileTagsView | PlainMessage<ProfileTagsView> | undefined, b: ProfileTagsView | PlainMessage<ProfileTagsView> | undefined): boolean {
    return proto3.util.equals(ProfileTagsView, a, b);
  }
}

/**
 * Profile photo details.
 *
 * @generated from message gdx.common.v1.ProfilePhoto
 */
export class ProfilePhoto extends Message<ProfilePhoto> {
  /**
   * @generated from field: string file_id = 1;
   */
  fileId = "";

  /**
   * @generated from field: bool is_dummy = 2;
   */
  isDummy = false;

  /**
   * @generated from field: repeated string tags = 3;
   */
  tags: string[] = [];

  constructor(data?: PartialMessage<ProfilePhoto>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.common.v1.ProfilePhoto";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "file_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "is_dummy", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "tags", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ProfilePhoto {
    return new ProfilePhoto().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ProfilePhoto {
    return new ProfilePhoto().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ProfilePhoto {
    return new ProfilePhoto().fromJsonString(jsonString, options);
  }

  static equals(a: ProfilePhoto | PlainMessage<ProfilePhoto> | undefined, b: ProfilePhoto | PlainMessage<ProfilePhoto> | undefined): boolean {
    return proto3.util.equals(ProfilePhoto, a, b);
  }
}

/**
 * Geo location value representation used in user profile.
 *
 * @generated from message gdx.common.v1.ProfileLocation
 */
export class ProfileLocation extends Message<ProfileLocation> {
  /**
   * @generated from field: string country = 1;
   */
  country = "";

  /**
   * @generated from field: string state = 2;
   */
  state = "";

  /**
   * @generated from field: string city = 3;
   */
  city = "";

  /**
   * @generated from field: gdx.common.v1.GeoPoint point = 4;
   */
  point?: GeoPoint;

  constructor(data?: PartialMessage<ProfileLocation>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.common.v1.ProfileLocation";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "country", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "state", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "city", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "point", kind: "message", T: GeoPoint },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ProfileLocation {
    return new ProfileLocation().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ProfileLocation {
    return new ProfileLocation().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ProfileLocation {
    return new ProfileLocation().fromJsonString(jsonString, options);
  }

  static equals(a: ProfileLocation | PlainMessage<ProfileLocation> | undefined, b: ProfileLocation | PlainMessage<ProfileLocation> | undefined): boolean {
    return proto3.util.equals(ProfileLocation, a, b);
  }
}

/**
 * Describes geo point.
 *
 * @generated from message gdx.common.v1.GeoPoint
 */
export class GeoPoint extends Message<GeoPoint> {
  /**
   * @generated from field: float latitude = 1;
   */
  latitude = 0;

  /**
   * @generated from field: float longitude = 2;
   */
  longitude = 0;

  constructor(data?: PartialMessage<GeoPoint>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.common.v1.GeoPoint";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "latitude", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 2, name: "longitude", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): GeoPoint {
    return new GeoPoint().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): GeoPoint {
    return new GeoPoint().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): GeoPoint {
    return new GeoPoint().fromJsonString(jsonString, options);
  }

  static equals(a: GeoPoint | PlainMessage<GeoPoint> | undefined, b: GeoPoint | PlainMessage<GeoPoint> | undefined): boolean {
    return proto3.util.equals(GeoPoint, a, b);
  }
}

/**
 * Full version of user profile info.
 *
 * @generated from message gdx.common.v1.ProfileInfo
 */
export class ProfileInfo extends Message<ProfileInfo> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: gdx.common.v1.ProfilePhoto avatar = 2;
   */
  avatar?: ProfilePhoto;

  /**
   * @generated from field: string name = 3;
   */
  name = "";

  /**
   * @generated from field: uint32 age = 4;
   */
  age = 0;

  /**
   * @generated from field: string location_name = 5;
   */
  locationName = "";

  /**
   * @generated from field: string about = 6;
   */
  about = "";

  /**
   * @generated from field: string religion = 7;
   */
  religion = "";

  /**
   * @generated from field: string sexual_orientation = 8;
   */
  sexualOrientation = "";

  /**
   * @generated from field: repeated string interests = 9;
   */
  interests: string[] = [];

  /**
   * @generated from field: string work_position = 10;
   */
  workPosition = "";

  /**
   * @generated from field: string gender = 11;
   */
  gender = "";

  /**
   * @generated from field: string match_gender = 12;
   */
  matchGender = "";

  /**
   * @generated from field: google.protobuf.Timestamp created_time = 13;
   */
  createdTime?: Timestamp;

  /**
   * @generated from field: string eye_color = 14;
   */
  eyeColor = "";

  /**
   * @generated from field: string hair_color = 15;
   */
  hairColor = "";

  /**
   * @generated from field: string ethnicity = 16;
   */
  ethnicity = "";

  /**
   * @generated from field: string body_type = 17;
   */
  bodyType = "";

  /**
   * @generated from field: string education = 18;
   */
  education = "";

  /**
   * @generated from field: string sphere_of_work = 19;
   */
  sphereOfWork = "";

  /**
   * @generated from field: string marital_status = 20;
   */
  maritalStatus = "";

  /**
   * @generated from field: string children = 21;
   */
  children = "";

  /**
   * @generated from field: repeated string tags = 22;
   */
  tags: string[] = [];

  /**
   * @generated from field: google.protobuf.Timestamp updated_time = 23;
   */
  updatedTime?: Timestamp;

  /**
   * @generated from field: gdx.common.v1.AccountStatus status = 24;
   */
  status = AccountStatus.INVALID;

  /**
   * @generated from field: string email = 25;
   */
  email = "";

  /**
   * @generated from field: google.protobuf.Timestamp birthday_time = 26;
   */
  birthdayTime?: Timestamp;

  /**
   * @generated from field: gdx.common.v1.ProfileLocation location = 27;
   */
  location?: ProfileLocation;

  /**
   * @generated from field: float fraud_score = 28;
   */
  fraudScore = 0;

  /**
   * @generated from field: string zodiac = 29;
   */
  zodiac = "";

  /**
   * @generated from field: google.protobuf.Timestamp last_status_updated_time = 30;
   */
  lastStatusUpdatedTime?: Timestamp;

  /**
   * To be continue on demand...
   *
   * @generated from field: google.protobuf.Timestamp status_expired_time = 31;
   */
  statusExpiredTime?: Timestamp;

  constructor(data?: PartialMessage<ProfileInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.common.v1.ProfileInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "avatar", kind: "message", T: ProfilePhoto },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "age", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 5, name: "location_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "about", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "religion", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "sexual_orientation", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "interests", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 10, name: "work_position", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "gender", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "match_gender", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "created_time", kind: "message", T: Timestamp },
    { no: 14, name: "eye_color", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "hair_color", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 16, name: "ethnicity", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 17, name: "body_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 18, name: "education", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 19, name: "sphere_of_work", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 20, name: "marital_status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 21, name: "children", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 22, name: "tags", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 23, name: "updated_time", kind: "message", T: Timestamp },
    { no: 24, name: "status", kind: "enum", T: proto3.getEnumType(AccountStatus) },
    { no: 25, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 26, name: "birthday_time", kind: "message", T: Timestamp },
    { no: 27, name: "location", kind: "message", T: ProfileLocation },
    { no: 28, name: "fraud_score", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 29, name: "zodiac", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 30, name: "last_status_updated_time", kind: "message", T: Timestamp },
    { no: 31, name: "status_expired_time", kind: "message", T: Timestamp },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ProfileInfo {
    return new ProfileInfo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ProfileInfo {
    return new ProfileInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ProfileInfo {
    return new ProfileInfo().fromJsonString(jsonString, options);
  }

  static equals(a: ProfileInfo | PlainMessage<ProfileInfo> | undefined, b: ProfileInfo | PlainMessage<ProfileInfo> | undefined): boolean {
    return proto3.util.equals(ProfileInfo, a, b);
  }
}

/**
 * Describes profile timezone.
 *
 * @generated from message gdx.common.v1.Timezone
 */
export class Timezone extends Message<Timezone> {
  /**
   * @generated from field: string timezone = 1;
   */
  timezone = "";

  /**
   * @generated from field: int32 offset_minutes = 2;
   */
  offsetMinutes = 0;

  constructor(data?: PartialMessage<Timezone>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "gdx.common.v1.Timezone";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "timezone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "offset_minutes", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Timezone {
    return new Timezone().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Timezone {
    return new Timezone().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Timezone {
    return new Timezone().fromJsonString(jsonString, options);
  }

  static equals(a: Timezone | PlainMessage<Timezone> | undefined, b: Timezone | PlainMessage<Timezone> | undefined): boolean {
    return proto3.util.equals(Timezone, a, b);
  }
}

